









































// vendor
import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
// local
import { HTML } from "../../ts/types/ItemSettings";
import { default as TemplateButton } from "./html-template-button.vue";


const insertText = (v:string, target:string, index:number) => {
	return target.slice(0, index) + v + target.slice(index);
};


// function setValueAndUpdateUndoStack(textarea:HTMLTextAreaElement, text:string) {
// 	// Must select all, so that the old text is deleted.
// 	textarea.focus();
// 	textarea.select();
	
// 	// https://stackoverflow.com/a/55174561/3480193
// 	if ( ! document.execCommand('insertText', false, text) ) {
// 		textarea.setRangeText(text);
// 	}
// };

export default defineComponent({
	props:{
		data:{
			type:Object as PropType<HTML>,
			required:true
		}
	},
	components:{
		TemplateButton
	},
	setup(props, context){

		const textBox = ref<HTMLTextAreaElement>();

		const content = computed({
			get:() => props.data.content,
			set:v => props.data.content = v
		});

		const appendTemplate = (t:string) => {
			const tb = textBox.value;
			if(!tb){ return; }

			const focusPos = tb.selectionStart + t.length;

			content.value = insertText(t, content.value, tb.selectionStart);
			setTimeout(() => {
				tb.focus();
				tb.select();
				tb.setSelectionRange(focusPos, focusPos);
			}, 1);
		};

		return {
			textBox,
			content,
			appendTemplate,
		};
	}
});

